export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-teal-600 via-cyan-700 to-teal-800 text-white overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/2c79df6a13c2cd82080a0b0b05c244cf.jpg"
          alt="智能文档处理解决方案背景"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-40">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl lg:text-7xl font-bold mb-8 leading-tight">
            <span className="text-teal-200">智能文档处理解决方案</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-teal-100 mb-12 leading-relaxed max-w-3xl mx-auto">
            专业提供<strong>Adobe PDF Library SDK</strong>、<strong>PDF Converter</strong>和<strong>PDF Form Extension</strong>，助力企业实现文档数字化转型。Datalogics中国大陆指定合作伙伴，已服务<strong>800+企业客户</strong>，覆盖金融、医疗、教育等多个行业。
          </p>
          
          <div className="flex flex-wrap justify-center gap-6">
            <a 
              href="/products" 
              className="bg-white text-teal-600 px-10 py-5 rounded-lg text-lg font-semibold hover:bg-teal-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              浏览产品
            </a>
            <a 
              href="/contact" 
              className="bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-10 py-5 rounded-lg text-lg font-semibold hover:from-teal-600 hover:to-cyan-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer border-2 border-white"
            >
              联系我们
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}